module.exports = __webpack_public_path__ + "static/img/Honda_ROBOTS_0010_B18_Final.947b9fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Honda_ROBOTS_0010_B18_Final.jpg
// module id = gQER
// module chunks = 0